
import HttpClient from '../core/HttpClient';
import Endpoints from '../../constants/endpoints';
import { LoginResponse, VerifyOtpResponse, DeleteAccountResponse } from './authModels';
import { ApiResponse } from '../core/HttpTypes';  
const http = new HttpClient();


export const LoginUser = async (
  email: string,
  password: string,
  deviceType: string,
  deviceName: string,
  deviceId: string
): Promise<LoginResponse> => {
  const res = await http.post<ApiResponse>(Endpoints.LOGIN, {
    email,
    password,
    deviceType,
    deviceName,
    deviceId
  });
  console.log('Login response:', res);
  console.log('Login Data response:', res.data);
  // Defensive check
  if (!res.data) {
    throw new Error('Login failed: Missing access token');
  }
  const loginResponse = new LoginResponse(res.data.data);
  return loginResponse;
};


  
// Verify OTP API
export const VerifyOtp = async (
  verificationToken: string,
  otp: string,
  type: string
): Promise<VerifyOtpResponse> => {
  console.log('Calling LoginUser API...');
  const res = await http.post<VerifyOtpResponse>(Endpoints.VERIFY_OTP, {
    verificationToken,
    otp,
    type,
  });
  console.log('VerifyOtp response:', res.data);
  return res.data;
};

 // Delete Account API
export const DeleteAccount = async (
  email: string,
  password: string
): Promise<DeleteAccountResponse> => {
  console.log('Attempting Delete Account for user', email);
  const res = await http.post<ApiResponse>(Endpoints.DELETE_ACCOUNT, {
    email,
    password,
  });
  console.log('DeleteAccount res:', res);
  console.log('DeleteAccount res data:', res.data);
  console.log('DeleteAccount res data status:', res.data.status);
  console.log('DeleteAccount res status:', res.status);
  let success = (res.status === 200);
  const deleteAccountResponse = new DeleteAccountResponse(success,res.data.message);
  return deleteAccountResponse
};